// extracted by mini-css-extract-plugin
export default {"md":"markdown_md__dTPbj","large":"markdown_large__tCP2r"};